import React, { useState, useEffect, useCallback } from "react";
import './../../App.css';
import './Maintenance.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import {SetAuditTrail, SetAuditTrailBulk} from './../Reports/AuditTrailReportEmployeeSetup';
import axios from 'axios';
import {token, domain} from './../Security';
import loadingSpinner from './../../assets/loading.gif';
import {useTable, useSortBy} from 'react-table';
// icons
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import SearchIcon from '@mui/icons-material/Search';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function Holiday({user, isHideSideMenu}) {
    var header = [
        "ID",
        "Description",
        "Holiday Date",
        "Holiday Type Description",
        "Location",
        "",
    ]
    var accessor = [
        "id",
        "description",
        "date",
        "holidayTypeDescription",
        "locations",
        "manage"
    ]

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [holiday, setHoliday] = useState([]);
    // Add
    const [showAddForm, setShowAddForm] = useState(false);
    const [description, setDescription] = useState("");
    const [date, setDate] = useState();
    const [holidayTypeId, setHolidayTypeId] = useState("");
    const [isAllLocation, setIsAllLocation] = useState(false);
    const [locations, setLocations] = useState([]);
    // Retrieve
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [dataToFetch, setDataToFetch] = useState("");
    const [searchPlaceholder, setSearchPlaceholder] = useState("description");
    // Update
    const [showEditForm, setShowEditForm] = useState(false);
    const [editById, setEditById] = useState("");
    const [editDescription, setEditDescription] = useState("");
    const [editDate, setEditDate] = useState("");
    const [editHolidayTypeId, setEditHolidayTypeId] = useState("");
    const [oldEditDescription, setOldEditDescription] = useState("");
    const [oldEditDate, setOldEditDate] = useState("");
    const [oldEditHolidayTypeId, setOldEditHolidayTypeId] = useState("");

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 1500);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end
    
    const apiUrl =  domain + "/api/Holiday";

    const fetchData = useCallback(async (dataToFetch) => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl + dataToFetch , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setHoliday(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl]);

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("description")
                setDataToFetch("");
                break;
            case 1:
                setSearchPlaceholder("holiday id")
                setDataToFetch("/description");
                break;
            default:
                setDataToFetch("");
                break;
        }
        fetchData(dataToFetch);
    }, [filterDataIndex, dataToFetch, fetchData]);

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];
        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.description.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.id.toString().startsWith(value)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.description.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }
        setHoliday(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            description: description,
            date: date,
            holidayTypeId: holidayTypeId,
            isAllLocation: isAllLocation,
            locations: locations.map(i => ({
                locationId: parseInt(i.locationId)  // Wrap in parentheses `()` to return an object
            }))
        };

        console.log('Final bulkData:', JSON.stringify(data, null, 2));

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowAddForm(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Holiday", 
                actionTaken: "insert", 
                field: "Add", 
                newValue: `${data.description}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchData(""); // Assuming fetchData() fetches the updated data for the table

            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setDescription("");
            setDate("");
            setHolidayTypeId("");
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAddForm(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            description: editDescription,
            date: editDate,
            holidayTypeId: editHolidayTypeId,
            isAllLocation: isAllLocation,
            locations: locations.map(i => ({
                locationId: parseInt(i.locationId)  // Wrap in parentheses `()` to return an object
            }))
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/${editById}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowEditForm(false);
            let auditInfo = [];

            if(data.description !== oldEditDescription){
                auditInfo.push({
                    setupArea: "Holiday",
                    actionTaken: "update",
                    field: "Description",
                    newValue: `${data.description}`,
                    oldValue: `${oldEditDescription}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.date !== oldEditDate){
                auditInfo.push({
                    setupArea: "Holiday",
                    actionTaken: "update",
                    field: "Date",
                    newValue: `${data.date}`,
                    oldValue: `${oldEditDate}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.holidayTypeId !== oldEditHolidayTypeId){
                auditInfo.push({
                    setupArea: "Holiday",
                    actionTaken: "update",
                    field: "Holiday Type",
                    newValue: `${holidayTypeId}`,
                    oldValue: `${oldEditHolidayTypeId}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            await SetAuditTrailBulk({data: auditInfo});
            await fetchData(""); // Assuming fetchData() fetches the updated data for the table

            setShowRequestMessage(true);
            setIsSuccess(true);

            // Reload table data and reset form fields
            setEditDescription("");
            setEditDate("");
            setEditHolidayTypeId("");
            setEditById("");
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditForm(false);
    };
    const handleDelete = async (event) => {
        event.preventDefault();

        try {
            setLoadingRequest(true);
            await axios.delete(apiUrl + `/${selectedData.id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowDeleteForm(false);
            await SetAuditTrail({
                setupArea: "Holiday", 
                actionTaken: "delete", 
                field: "Delete", 
                newValue: `${selectedData.description}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchData(""); // Assuming fetchData() fetches the updated data for the table

            setShowRequestMessage(true);
            setIsSuccess(true);

            setSelectedData(null);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowDeleteForm(false);
    };

    const addHandleClick = () => {
        setShowAddForm(true);
    };
    const editHandleClick = (data) => {
        setEditById(data.id);
        setEditDescription(data.description);
        setEditDate(data.date);
        setEditHolidayTypeId(data.holidayTypeId);
        setIsAllLocation(data.isAllLocation);
        setLocations(data.locations);
        setOldEditDescription(data.description);
        setOldEditDate(data.date);
        setOldEditHolidayTypeId(data.holidayTypeId);
        setShowEditForm(true);
    };

    const [showDeleteForm, setShowDeleteForm] = useState(false);
    const [selectedData, setSelectedData] = useState(null);
    const deleteHandleClick = (data) => {
        setSelectedData(data);
        setShowDeleteForm(true);
    }
    const closeAddHandleClick = () => {
        setShowAddForm(false);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };
    const closeDeleteHandleClick = () => {
        setShowDeleteForm(false);
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="MainteInfo shadow-xl">
                        <div className="mainteHeader">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Maintenance >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Holiday"}</span>
                            </div>
                            <h3>Holiday</h3>
                        </div>
                        <div className="mainte-body">
                            {Filter(setFilterDataIndex)}
                            <div className="mainte-body-top row">
                                {CreateSearchBarWithPlaceHolder("", "mainte-search row", "mainte-search-icon", "mainte-search-input", (e) => handleFilter(e.target.value), "Search by " + searchPlaceholder, SearchIcon)}
                                <div className="mainte-addBtn row">
                                    {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                                </div>
                            </div>
                            <div className="maintenance-table container">
                                <CreateTable
                                    dataList={holiday}
                                    dataHeader={header}
                                    dataAccessor={accessor}
                                    editHandleClick={editHandleClick}
                                    deleteHandleClick={deleteHandleClick}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddForm  isOpen={showAddForm} 
                    onClose={closeAddHandleClick}
                    description={description}
                    date={date}
                    holidayTypeId={holidayTypeId}
                    setDescription={setDescription}
                    setDate={setDate}
                    setHolidayTypeId={setHolidayTypeId}
                    isAllLocation={isAllLocation}
                    setIsAllLocation={setIsAllLocation}
                    locations={locations}
                    setLocations={setLocations}
                    handleSubmit={handleSubmit}
            >
            </AddForm>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    editDescription={editDescription}
                    editDate={editDate}
                    editHolidayTypeId={editHolidayTypeId}
                    setEditDescription={setEditDescription}
                    setEditDate={setEditDate}
                    setEditHolidayTypeId={setEditHolidayTypeId}
                    isAllLocation={isAllLocation}
                    setIsAllLocation={setIsAllLocation}
                    locations={locations}
                    setLocations={setLocations}
                    handleUpdate={handleUpdate}
            >
            </EditForm>
            <DeleteForm  isOpen={showDeleteForm} 
                    onClose={closeDeleteHandleClick}
                    handleDelete={handleDelete}
            >
            </DeleteForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function AddForm({
    isOpen,
    onClose,
    description,
    date,
    holidayTypeId,
    setDescription,
    setDate,
    setHolidayTypeId,
    isAllLocation,
    setIsAllLocation,
    locations,
    setLocations,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);
    const [locationId, setLocationId] = useState("");
    const [locationDescription, setLocationDescription] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const submit = (e) =>{
        if(!description 
        || !date 
        || !holidayTypeId){
            setErrorState(true);
            return;
        }

        if(locations.length <= 0 && !isAllLocation){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage(`Please choose a location or tick the 'Is All Location?' checkbox`);
            return;
        }

        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setDescription("");
        setDate("");
        setHolidayTypeId("");
        setLocationId("");
        setIsAllLocation(false);
        setLocations([]);
        setErrorState(false);
        setIsAddState(false);
    };

    const handleHolidayTypeIdChange = (event) => {
        setHolidayTypeId(event.target.value);
    };
    
    const [isAddState, setIsAddState] = useState(false);
    const addHandleClick = () => {
        setIsAddState(true);
    }
    const saveLocation = () =>{
        if(!locationId){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please select location");
            return;
        }

        if(locations.find(i => i.id === locationId)){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage(`${locationDescription} is already added.`);
            return;
        }

        const data = {
            id: locationId,
            locationId: locationId,
            locationDescription: locationDescription
        }

        setLocations((prev) => [...prev, data])
        setLocationId("");
        setLocationDescription("");
        setIsAddState(false);
    }
    const cancelLocation = () =>{
        setIsAddState(false);
    }
    const removeLocation = (data) => {
        setLocations((prev) => prev.filter((location) => location.id !== data.id));
    };

    const generateLoc = () => {
        return locations.length > 0 
            ? locations.map((location) => (
                <div className="row" style={{alignItems: "center", margin: "5px 0"}}>
                    <span key={location.id}>{location.locationDescription}</span>
                    <button
                        id="add-family"
                        className="cancel row"
                        onClick={()=>removeLocation(location)}
                        style={{marginLeft: "10px", height: "20px"}}
                    >
                        remove
                    </button>
                </div>
            ))
            : <span>No location selected</span>;
    };

    const handleIsAllLocation = (event) => {
        setIsAllLocation(event.target.checked);
        setLocations([]);
        setIsAddState(false);
    }

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                    <div className="modal">
                        <div className="popUp-header row">
                            <div className="popUp-title">
                                <h3 style={{ color: "#668fca" }}>Add Holiday</h3>
                            </div>
                            <div className="popUp-close">
                                <CloseIcon onClick={handleClose} />
                            </div>
                        </div>
                        <div className="popUp-body">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Description</div>
                                <div className="info-item-input">
                                    <input
                                        id="description"
                                        placeholder="Description"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: !description && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Date</div>
                                <div className="info-item-input">
                                    <DateTimeInput date={date} setDate={setDate}/>
                                </div>
                                <span style={{
                                        visibility: !date && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Holiday Type</div>
                                <div className="info-item-input">
                                    <HolidayTypeIdSelect holidayTypeId={holidayTypeId} 
                                                        setHolidayTypeId={setHolidayTypeId} 
                                                        handleHolidayTypeIdChange={handleHolidayTypeIdChange}/>
                                </div>
                                <span style={{
                                        visibility: !holidayTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                                <div className="info-item-label" style={{paddingRight:"10px"}}>Is All Location?</div>
                                <div className="info-item-input">
                                    <input type="checkbox" 
                                    id="isActive-checkbox" 
                                    className="checkbox" 
                                    name="" 
                                    checked={isAllLocation}
                                    onChange={(e)=>handleIsAllLocation(e)}/>
                                </div>
                            </div>
                            {!isAllLocation &&
                                <div className="popUp-item info-item">
                                    <div className="info-item-label" style={{paddingRight:"10px"}}>Locations</div>
                                    <div className="info-item-input column" style={{padding: "10px"}}>
                                        {generateLoc()}
                                    </div>
                                </div>
                            }

                            {!isAllLocation &&
                            <>
                                {!isAddState &&
                                    <button
                                        id="add-family"
                                        className="add row"
                                        onClick={()=>addHandleClick()}
                                    >
                                        Add Location
                                    </button>
                                }

                                { isAddState &&
                                    <>
                                        <div className="popUp-item info-item column">
                                            <div className="info-item-label">Location</div>
                                            <div className="info-item-input">
                                                <LocationIdSelect locationId={locationId} setLocationId={setLocationId} locationDescription={locationDescription} setLocationDescription={setLocationDescription} isAllLocation={isAllLocation}/>
                                            </div>
                                            <span style={{
                                                    visibility: (!locationId && errorState) || isAllLocation ? "visible" : "hidden",
                                                    color:"#ff6565", 
                                                    fontSize:"12px"}}>{isAllLocation ? "Already set as 'All Locations'" : "Please fill up this field"}
                                            </span>
                                        </div>
                                        <div className="row">
                                            <button
                                                id="add-family"
                                                className="save row"
                                                onClick={()=>saveLocation()}
                                            >
                                                Save
                                            </button>
                                            <button
                                                id="add-family"
                                                className="cancel row"
                                                onClick={()=>cancelLocation()}
                                                style={{marginLeft: "5px"}}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </>
                                }
                            </>
                            }
                        </div>
                        <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
                            <button
                                id="add-family"
                                className="save row"
                                onClick={(e)=>submit(e)}
                            >
                                SAVE
                            </button>
                        </div>
                    </div>
                )}
            </div>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
        </>
    );
}
function EditForm({isOpen, 
    onClose, 
    editDescription, 
    editDate, 
    editHolidayTypeId, 
    setEditDescription, 
    setEditDate, 
    setEditHolidayTypeId, 
    isAllLocation,
    setIsAllLocation,
    locations,
    setLocations,
    handleUpdate})
{
    const [errorState, setErrorState] = useState(false);
    const [locationId, setLocationId] = useState("");
    const [locationDescription, setLocationDescription] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const submit = (e) =>{
        if(!editDescription 
        || !editDate 
        || !editHolidayTypeId){
            setErrorState(true);
            return;
        }

        if(locations.length <= 0 && !isAllLocation){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage(`Please choose a location or tick the 'Is All Location?' checkbox`);
            return;
        }

        handleUpdate(e);
        setErrorState(false);
    };
    // Function to handle closing the modal
    const handleClose = () => {
        onClose();
        setLocationId("");
        setLocationDescription("");
        setLocations([]);
        setIsAllLocation(false);
        setErrorState(false);
    };

    const handleDescriptionChange = (event) => {
        setEditDescription(event.target.value);
    };
    
    const handleHolidayTypeIdChange = (event) => {
        setEditHolidayTypeId(event.target.value);
    };

    const [isAddState, setIsAddState] = useState(false);
    const addHandleClick = () => {
        setIsAddState(true);
    }
    const saveLocation = () =>{
        if(!locationId){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please select location");
            return;
        }

        if(locations.find(i => i.id === locationId)){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage(`${locationDescription} is already added.`);
            return;
        }

        const data = {
            id: locationId,
            locationId: locationId,
            locationDescription: locationDescription
        }

        setLocations((prev) => [...prev, data])
        setLocationId("");
        setLocationDescription("");
        setIsAddState(false);
    }
    const cancelLocation = () =>{
        setIsAddState(false);
    }
    const removeLocation = (data) => {
        setLocations((prev) => prev.filter((location) => location.id !== data.id));
    };

    const generateLoc = () => {
        return locations.length > 0 
            ? locations.map((location) => (
                <div className="row" style={{alignItems: "center", margin: "5px 0"}}>
                    <span key={location.id}>{location.locationDescription}</span>
                    <button
                        id="add-family"
                        className="cancel row"
                        onClick={()=>removeLocation(location)}
                        style={{marginLeft: "10px", height: "20px"}}
                    >
                        remove
                    </button>
                </div>
            ))
            : <span>No location selected</span>;
    };

    const handleIsAllLocation = (event) => {
        setIsAllLocation(event.target.checked);
        setLocations([]);
        setIsAddState(false);
    }

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Holiday</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Description</div>
                            <div className="info-item-input">
                                <input
                                id="description"
                                placeholder="Description"
                                value={editDescription}
                                onChange={(e) => handleDescriptionChange(e)}
                                />
                            </div>
                            <span style={{
                                    visibility: !editDescription && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date</div>
                            <div className="info-item-input">
                                <DateTimeInput date={editDate} setDate={setEditDate}/>
                            </div>
                            <span style={{
                                    visibility: !editDate && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Holiday Type</div>
                            <div className="info-item-input">

                                <HolidayTypeIdSelect holidayTypeId={editHolidayTypeId}
                                                    setHolidayTypeId={setEditHolidayTypeId}
                                                    handleHolidayTypeIdChange={handleHolidayTypeIdChange}/>
                            </div>
                            <span style={{
                                    visibility: !editHolidayTypeId && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is All Location?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={isAllLocation}
                                onChange={(e)=>handleIsAllLocation(e)}/>
                            </div>
                        </div>
                        {!isAllLocation &&
                            <div className="popUp-item info-item">
                                <div className="info-item-label" style={{paddingRight:"10px"}}>Locations</div>
                                <div className="info-item-input column" style={{padding: "10px"}}>
                                    {generateLoc()}
                                </div>
                            </div>
                        }

                        {!isAllLocation &&
                        <>
                            {!isAddState &&
                                <button
                                    id="add-family"
                                    className="add row"
                                    onClick={()=>addHandleClick()}
                                >
                                    Add Location
                                </button>
                            }

                            { isAddState &&
                                <>
                                    <div className="popUp-item info-item column">
                                        <div className="info-item-label">Location</div>
                                        <div className="info-item-input">
                                            <LocationIdSelect locationId={locationId} setLocationId={setLocationId} locationDescription={locationDescription} setLocationDescription={setLocationDescription} isAllLocation={isAllLocation}/>
                                        </div>
                                        <span style={{
                                                visibility: (!locationId && errorState) || isAllLocation ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>{isAllLocation ? "Already set as 'All Locations'" : "Please fill up this field"}
                                        </span>
                                    </div>
                                    <div className="row">
                                        <button
                                            id="add-family"
                                            className="save row"
                                            onClick={()=>saveLocation()}
                                        >
                                            Save
                                        </button>
                                        <button
                                            id="add-family"
                                            className="cancel row"
                                            onClick={()=>cancelLocation()}
                                            style={{marginLeft: "5px"}}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </>
                            }
                        </>
                        }
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
        </>
    );
}
function DeleteForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to delete this holiday?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleDelete}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function HolidayTypeIdSelect({holidayTypeId, setHolidayTypeId, handleHolidayTypeIdChange}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        handleHolidayTypeIdChange(event);
        setHolidayTypeId(event.target.value);
        };
    
    const [holidayTypeIds, setHolidayTypeIds] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/HolidayType/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setHolidayTypeIds(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(holidayTypeId !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [holidayTypeId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={holidayTypeId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose holiday type</option>
            {holidayTypeIds.map((holidayTypeId) => ( 
                SetHolidayTypes(holidayTypeId)
            ))}
            </select>
        </div>
    );
};
function SetHolidayTypes(holidayTypeId){
    return(
        <option id={"holidayType" + holidayTypeId.id} value={holidayTypeId.id}>{holidayTypeId.description}</option>
    )
    
}
function DateTimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    let formattedDate = "";

    if(date){
        formattedDate = date.split('T')[0];
    }

    return (
        <div>
            <input
            type="date"
            id={"datetime-"}
            name="datetime"
            value={formattedDate}
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "HolidayId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="HolidayId">Holiday Id</option>
            </select>
        </div>
    );
};
function LocationIdSelect({locationId, setLocationId, locationDescription, setLocationDescription, isAllLocation}){
    const [isSelected, setIsSelected] = useState(false);

    const [data, setData] = useState([]);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setLocationId(event.target.value);

        const selected = data.find(i => i.id === parseInt(event.target.value))
        setLocationDescription(selected.description);
    };

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(locationId !== "" && locationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [locationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" disabled={isAllLocation} value={locationId || ""} onChange={handleSelectChange}style={{ height: "30px", color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose a location</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}
export function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, editHandleClick, deleteHandleClick }) {
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <>
            <table {...getTableProps()} className='border-collapse'>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                    {...column.getHeaderProps()}
                                    onClick={() => headerClick(column)}
                                    className="sortable-header"
                                >
                                    {`${column.render("Header")} ${
                                        sortHeaderValue.id === column.id
                                            ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                            : ""
                                    }`}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    SetInfo(cell.render("Cell").props.column.Header, 
                                            cell,
                                            editHandleClick,
                                            deleteHandleClick)
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </>
            ) :
            <></>}
        </>
    )
}
function SetInfo(header, _cell, editHandleClick, deleteHandleClick) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    || header === "Date Requested"
    ){
        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    if(header === "Holiday Date"){
        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();

        const formattedDateFrom = `${mm}/${dd}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    if (header === "Location") {
        if (data.isAllLocation) {
            return <td>All Locations</td>;
        }
        
        return (
            <td>
                {value.map((location) => (
                    <>
                        {location.locationDescription}
                        <br />
                    </>
                ))}
            </td>
        );
    }    

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
export default Holiday
